import Error from './Error';
import Video from './Video';
import FiledownRename from './FiledownRename';
import Detail from './Detail';
import UserDetail from './UserDetail';
import UserDelPwd from './UserDelPwd';
import Notice from './Notice';

export {
    Error,
    Video,
    FiledownRename,
    Detail,
    UserDetail,
    UserDelPwd,
    Notice
};



// WEBPACK FOOTER //
// ./src/components/modal/index.js